// @flow
import { set } from "splitster-redux"
import Cookies from "js-cookie"
import * as R from "ramda"

import { get } from "common/utils/get"
import has from "common/utils/has"
import castArray from "common/utils/castArray"
import mapValues from "common/utils/mapValues"
import { showModal } from "common/services/modals/actions"
import { hashBannerText } from "common/services/remoteConfig/bannerHelper"
import { setBanner, setDelayedChat, setChatModal } from "common/services/remoteConfig/actions"
import maybeTranslate from "./maybeTranslate"
import type { Banners } from "./banner.types"

const splitsterHasTest = (testId, splitsterTests) => has([testId], splitsterTests)

const bindWindowGlobalFunctions = () => {
  // ==== Remote configuration
  window.globalSetExponeaBanner = (text: Banners, showOnMobile: boolean = false) => {
    const closedBanners = castArray(Cookies.getJSON("closedBanners"))
    const banners = R.compose(
      R.filter(banner => !closedBanners.includes(hashBannerText(banner.text))),
      castArray,
    )(text)

    if (banners.length) {
      window.reduxStore.dispatch(setBanner(banners, showOnMobile)) // ensure array is inserted
    }
  }
  window.globalSetChatModal = text => {
    window.reduxStore.dispatch(setChatModal(text))
  }
  window.globalShowDelayedChat = input => {
    const {
      chatEnabled = true,
      titleText = null,
      titleTextTranslation = null,
      recoverText = null,
      alternativeContactText = null,
      alternativeContactLinkText = null,
      alternativeContactLinkAddress = null,
      // $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
    } = mapValues(maybeTranslate, input)

    window.reduxStore.dispatch(
      setDelayedChat(
        chatEnabled,
        titleText,
        titleTextTranslation,
        recoverText,
        alternativeContactText,
        alternativeContactLinkText,
        alternativeContactLinkAddress,
      ),
    )
  }
  window.globalShowMaintenanceModal = () => {
    window.reduxStore.dispatch(showModal("maintenance"))
  }

  // ==== Splitster
  window.toggleSplitsterTest = testId => {
    const splitsterTests = get(["splitster", "state", "tests"], window.reduxStore.getState())

    if (!splitsterHasTest(testId, splitsterTests)) return

    const { winningVariant, variants } = get(testId, splitsterTests)

    const variantId = R.compose(
      get("id"),
      R.head,
      R.filter(variant => variant !== winningVariant),
    )(variants)

    window.reduxStore.dispatch(set(testId, variantId, true))
  }
  window.setSplitsterTestVariant = (testId, variantId) => {
    const splitsterTests = get(["splitster", "tests"], window.reduxStore.getState())

    if (!splitsterHasTest(testId, splitsterTests)) return

    const variants = R.compose(
      Object.values,
      R.pluck("value"),
      get([testId, "variants"]),
    )(splitsterTests)

    if (variants.includes(variantId)) {
      window.reduxStore.dispatch(set(testId, variantId, true))
    }
  }
}

export default bindWindowGlobalFunctions
